import { Input } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { FormItem } from '../FormItem';
import styles from './Input.module.scss';
import cn from 'classnames';

interface InputI {
  name: string;
  label?: string;
  size?: SizeType;
  placeholder?: string;
  errorMessage?: string;
  type?: 'text' | 'number';
  defaultValue?: string | number;
}

const CustomInput = ({
  errorMessage,
  label = '',
  name,
  size = 'large',
  placeholder,
  type = 'text',
}: InputI) => {
  return (
    <div className={cn(styles.wrapper, { [styles.wrapper_withLabel]: label })}>
      {label && <div>{label}:</div>}
      <FormItem message={errorMessage} name={name}>
        <Input size={size} placeholder={placeholder} type={type} />
      </FormItem>
    </div>
  );
};

export default CustomInput;
